<template>
  <div class="grid-content content-margin">
        <div class="buttonarea">  
          <el-link
            :underline="false"
          >
          <el-button size="medium" round @click="createTarget" v-if="iscreate">
            <i class="iconfont" >&#xe727;</i>
            {{$t('message.新建')}}
          </el-button>
          </el-link>
          <el-link
            :underline="false"
          >
          <el-button size="medium" round @click.native="refresh">
            <i class="iconfont" >&#xe667;</i>
            {{$t('message.刷新')}}
          </el-button>
          </el-link>
          <slot></slot>
          <!-- <el-link
            :underline="false"
          >
            <el-button size="medium" round :loading="false" @click.native="exportDialogVisible = true">
              <i class="iconfont" >&#xe769;</i>
              导出
            </el-button>
          </el-link> -->
        </div>
      </div>
</template>

<script>
export default {
    name:'buttonarea',
    props:['iscreate'],
    methods:{
        createTarget(){
            this.$emit('createTarget')
        },
        refresh(){
            this.$emit('refresh')
        }
    }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/vipcom/buttonarea.vue